import React from 'react';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Chip } from '@mui/material';
import { getTransactions, Transaction } from '../services/dataService';

const Transactions: React.FC = () => {
  const transactions = getTransactions();

  const getStatusColor = (status: string): { color: string; bg: string } => {
    switch (status) {
      case 'completed':
        return { color: '#059669', bg: '#ECFDF5' };
      case 'pending':
        return { color: '#D97706', bg: '#FFFBEB' };
      case 'failed':
        return { color: '#DC2626', bg: '#FEF2F2' };
      default:
        return { color: '#6B7280', bg: '#F3F4F6' };
    }
  };

  return (
    <Box>
      <Typography 
        variant="h4" 
        sx={{ 
          mb: 4,
          color: '#111827',
          fontWeight: 'bold',
          letterSpacing: '-0.025em'
        }}
      >
        Transactions
      </Typography>
      <Paper 
        elevation={0}
        sx={{
          width: '100%',
          overflow: 'hidden',
          border: '1px solid #E5E7EB',
          borderRadius: 2,
        }}
      >
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell 
                  sx={{ 
                    bgcolor: '#F9FAFB',
                    color: '#6B7280',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                  }}
                >
                  Date
                </TableCell>
                <TableCell 
                  sx={{ 
                    bgcolor: '#F9FAFB',
                    color: '#6B7280',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                  }}
                >
                  Description
                </TableCell>
                <TableCell 
                  align="right"
                  sx={{ 
                    bgcolor: '#F9FAFB',
                    color: '#6B7280',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                  }}
                >
                  Amount
                </TableCell>
                <TableCell 
                  sx={{ 
                    bgcolor: '#F9FAFB',
                    color: '#6B7280',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                  }}
                >
                  Type
                </TableCell>
                <TableCell 
                  sx={{ 
                    bgcolor: '#F9FAFB',
                    color: '#6B7280',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                  }}
                >
                  Status
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transactions.map((transaction: Transaction) => (
                <TableRow 
                  key={transaction.id}
                  sx={{
                    '&:hover': {
                      bgcolor: '#F5F6FF',
                    },
                  }}
                >
                  <TableCell
                    sx={{
                      color: '#111827',
                      fontWeight: 500,
                      fontSize: '0.875rem',
                    }}
                  >
                    {transaction.date}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: '#111827',
                      fontWeight: 500,
                      fontSize: '0.875rem',
                    }}
                  >
                    {transaction.description}
                  </TableCell>
                  <TableCell 
                    align="right"
                    sx={{
                      color: transaction.type === 'credit' ? '#059669' : '#DC2626',
                      fontWeight: 600,
                      fontSize: '0.875rem',
                    }}
                  >
                    {transaction.type === 'credit' ? '+' : '-'}${Math.abs(transaction.amount).toLocaleString()}
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={transaction.type}
                      size="small"
                      sx={{
                        bgcolor: transaction.type === 'credit' ? '#ECFDF5' : '#FEF2F2',
                        color: transaction.type === 'credit' ? '#059669' : '#DC2626',
                        fontWeight: 500,
                        fontSize: '0.75rem',
                        borderRadius: '4px',
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={transaction.status}
                      size="small"
                      sx={{
                        bgcolor: getStatusColor(transaction.status).bg,
                        color: getStatusColor(transaction.status).color,
                        fontWeight: 500,
                        fontSize: '0.75rem',
                        borderRadius: '4px',
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default Transactions; 